<p-card>
  <ng-template pTemplate="header">
    <div class="title-visualizacao"><span class="cl-blue">Nome da Competência: </span>
      <span>{{competenciaLocal.nome}}</span>
    </div>
  </ng-template>
  <div class="p-fluid">
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Id:</label>
      <div class="p-col-12 p-md-10">{{competenciaLocal.id}}</div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Origem: </label>
      <div class="p-col-12 p-md-10">{{competenciaLocal.origemId}}</div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Competência: </label>
      <div class="p-col-12 p-md-10"><a [routerLink]="['/competencia/visualizar/',competenciaLocal.competencia?.id]" title="Visualizar Assunto">{{competenciaLocal.competencia?.nome}}</a></div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Nome: </label>
      <div class="p-col-12 p-md-10">{{competenciaLocal.nome}}</div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6">
        <button pButton appBotaoVoltar class="p-button-primary  p-lg-12" label="Voltar"></button>
      </div>
      <div class="p-field p-col-6">
         <button pButton (click)="sincronizarPorId()" class="p-button-primary  p-lg-12" label="Sincronizar"></button>
      </div>
    </div>
  </ng-template>

  <br/>

  <p-tabView [(activeIndex)]="tabViewIndex" (onChange)="onChangeTabView()">
    <p-tabPanel header="Órgãos julgadores" leftIcon="pi pi-id-card">
      <p-table
        [value]="competenciaLocal.orgaosJulgadores"
        responsive="true"
        responsiveLayout="scroll"
        styleClass="p-datatable-striped">
        <ng-template pTemplate="header">
          <tr>
            <th class="p-text-break" style="width: 15%">Id</th>
            <th class="p-text-break" style="width: 20%">Origem Id.</th>
            <th class="p-text-break">Nome</th>
            <th class="p-text-break" style="width: 10%">Data Inicio</th>
            <th class="p-text-break" style="width: 10%">Data Fim</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-orgaojulgador>
          <tr>
            <td>{{orgaojulgador.orgaoJulgadorLocal.id}}</td>
            <td>{{orgaojulgador.orgaoJulgadorLocal.origemId}}</td>
            <td><a [routerLink]="['/orgaoJulgadorLocal/visualizar/',orgaojulgador.orgaoJulgadorLocal.id]" title="Visualizar Assunto">{{orgaojulgador.orgaoJulgadorLocal.nome}}</a></td>
            <td>{{orgaojulgador.dataInicio | date:'dd/MM/yyyy HH:mm:ss'}}</td>
            <td>{{orgaojulgador.dataFim | date:'dd/MM/yyyy HH:mm:ss'}}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="6">Nenhum dado cadastrado</td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>
    <p-tabPanel header="Classes e Assuntos" leftIcon="pi pi-id-card">
      <p-table
        [value]="competenciaLocal.classeAssuntos"
        responsive="true"
        responsiveLayout="scroll"
        styleClass="p-datatable-striped">
        <ng-template pTemplate="header">
          <tr>
            <th class="p-text-break" style="width: 10%">Id</th>
            <th class="p-text-break" style="width: 10%">Origem Id</th>
            <th class="p-text-break" style="width: 20%">Classe</th>
            <th class="p-text-break" style="width: 20%">Assunto</th>
            <th class="p-text-break" style="width: 10%">Data Inicio</th>
            <th class="p-text-break" style="width: 10%">Data Fim</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-classeAssunto>
          <tr>
            <td>{{classeAssunto.classe.id}}</td>
            <td>{{classeAssunto.origemId}}</td>
            <td><a [routerLink]="['/classe/visualizar/',classeAssunto.classe.id]" title="Visualizar Classe">{{classeAssunto.classe.descricao}}</a></td>
            <td><a [routerLink]="['/assunto/visualizar/',classeAssunto.assunto.id]" title="Visualizar Assunto">{{classeAssunto.assunto.descricao}}</a></td>
            <td>{{classeAssunto.dataInicio | date:'dd/MM/yyyy HH:mm:ss'}}</td>
            <td>{{classeAssunto.dataFim | date:'dd/MM/yyyy HH:mm:ss'}}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="6">Nenhum dado cadastrado</td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>
  </p-tabView>


</p-card>
